var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWearables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6176 8.66667H18.9276C18.8735 6.82 17.3379 5.33333 15.4506 5.33333H15.4032L14.0368 0H4.90441L3.53118 5.33333H3.48382C1.56265 5.33333 0 6.87333 0 8.76667V23.2333C0 25.1267 1.56265 26.6667 3.48382 26.6667H3.53118L4.90441 32H14.0368L15.41 26.6667H15.4574C17.3785 26.6667 18.9412 25.1267 18.9412 23.2333V15.3333H19.6176C21.4847 15.3333 23 13.84 23 12C23 10.16 21.4847 8.66667 19.6176 8.66667ZM5.95971 1.33333H12.9815L14.0097 5.33333H4.93147L5.95971 1.33333ZM12.9815 30.6667H5.95971L4.93147 26.6667H14.0165L12.9882 30.6667H12.9815ZM17.5882 23.2333C17.5882 24.3933 16.6344 25.3333 15.4574 25.3333H3.48382C2.30676 25.3333 1.35294 24.3933 1.35294 23.2333V8.76667C1.35294 7.60667 2.30676 6.66667 3.48382 6.66667H15.4574C16.6344 6.66667 17.5882 7.60667 17.5882 8.76667V23.2333ZM19.6176 14H18.9412V10H19.6176C20.7338 10 21.6471 10.9 21.6471 12C21.6471 13.1 20.7338 14 19.6176 14Z",
    fill: "#06A099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.647 16.6667H20.2941V23.3333H21.647V16.6667Z",
    fill: "#06A099"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWearables);
export default __webpack_public_path__ + "static/media/wearables.4f6b6d4d1e8ae1c7ae19b1469307ca95.svg";
export { ForwardRef as ReactComponent };